import React from 'react';
import { useTranslation } from 'react-i18next';

import { LabSampleType } from 'store/labSamples/types';
import { Banner } from 'common';

type ExternalLabSamplePropsType = {
  sample: LabSampleType;
};

export const ExternalLabSample = ({ sample }: ExternalLabSamplePropsType) => {
  const { t } = useTranslation();
  const externalLab = sample.nutrient_external_lab_identifier;

  return (
    <>
      {externalLab && (
        <Banner
          headingText={t('externalLabSample')}
          bodyText={`${t('externalLabSampleDestination')}: ${t(externalLab)}`}
        />
      )}
    </>
  );
};
